import React, { PureComponent, ReactElement } from 'react';

import { Checkbox } from '../..';

interface DataTableCheckboxProps {
  indeterminate: boolean;
  name?: string;
  onChange?: () => void;
  value: boolean;
}

class DataTableCheckbox extends PureComponent<DataTableCheckboxProps> {
  static defaultProps = {
    indeterminate: false,
    value: false,
  };

  onChange = (): void => {
    const { onChange } = this.props;

    onChange && onChange();
  };

  render(): ReactElement {
    const { name, value } = this.props;

    return (
      <Checkbox
        name={name}
        value={value}
        onChange={this.onChange}
        uuid={`data-table-checkbox-${name}`}
        label={''}
      />
    );
  }
}

export default DataTableCheckbox;
